import { Box } from '@mui/material';
import { JSX } from 'react';
import { PortableText } from '@portabletext/react';
import { SanityCategory } from '../../common/types/sanity';
import { useSanityQuery } from '../../common/hooks/useSanityQuery';

interface StepInstructionProps {
  /**
   * Name of the report section (category) that the instruction is for
   */
  sectionName: string;
}

/**
 * Fetch category data and display instruction if available
 */
const StepInstruction = ({ sectionName }: StepInstructionProps): JSX.Element | null => {
  const { data: categories } = useSanityQuery<SanityCategory[]>({
    queryKey: [
      `*[!(_id in path("drafts.**")) && title == "${sectionName}" && _type == "Category"]`,
    ],
  });
  const category = categories?.[0];

  if (!category?.instruction) {
    return null;
  }

  return (
    <Box className="mb-4" color="text.secondary">
      <PortableText value={category.instruction} />
    </Box>
  );
};

export default StepInstruction;
